import { parse } from '../../util/urlHelpers';

import axios from 'axios';
import { apiBaseUrl } from '../../util/api';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchCurrentWorkerUserExtraDetails } from '../../ducks/user.duck';

const RESULT_PAGE_SIZE = 18;

// ================ Action types ================ //

export const FETCH_ALL_BUSINESS_REQUEST = 'app/SuperAdminDashboard/FETCH_ALL_BUSINESS_REQUEST';
export const FETCH_ALL_BUSINESS_SUCCESS = 'app/SuperAdminDashboard/FETCH_ALL_BUSINESS_SUCCESS';
export const FETCH_ALL_BUSINESS_ERROR = 'app/SuperAdminDashboard/FETCH_ALL_BUSINESS_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchInProgress: false,
  fetchAllBusinessError: null,
  pagination: null,
  currentPageBusiness: [],
};

export default function SuperAdminDashboardBusinessPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_ALL_BUSINESS_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
        fetchAllBusinessError: null,
        currentPageBusiness: [],
      };
    case FETCH_ALL_BUSINESS_SUCCESS: {

      return {
        ...state,
        fetchInProgress: false,
        currentPageBusiness: payload.data.data,

        pagination: payload.data.meta,
      };
    }
    case FETCH_ALL_BUSINESS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchInProgress: false, fetchAllBusinessError: payload };

    default:
      return state;
  }
}
// ================ Action creators ================ //

const fetchAllBusinessRequest = () => ({ type: FETCH_ALL_BUSINESS_REQUEST });
const fetchAllBusinessSuccess = response => ({
  type: FETCH_ALL_BUSINESS_SUCCESS,
  payload: response,
});
const fetchAllBusinessError = e => ({
  type: FETCH_ALL_BUSINESS_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

export const fetchAllBusiness = param => (dispatch, getState, sdk) => {
  const { page = 1 } = param;
  return axios
    .get(`${apiBaseUrl()}/api/user/admin/allBusiness?page=${page}`, {
      withCredentials: true,
    })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(fetchAllBusinessSuccess(response));
    })
    .catch(error => {
      dispatch(fetchAllBusinessError(error));
    });
};
export const filterSearch = params => (dispatch, getState, sdk) => {
  dispatch(fetchAllBusinessRequest());
  const { searchName, search, page = 1 } = params;
  let paginationDetails;
  return axios
    .post(`${apiBaseUrl()}/api/user/findByIdOrName`, {
      searchItem: searchName,
      page,
      isProvider: true,
    })
    .then(res => {
      paginationDetails = {
        page: res?.data?.page,
        pageSize: res?.data?.pageSize,
        totalPages: res?.data?.totalPages,
        totalCount: res?.data?.totalCount,
      };
      const ids = res?.data?.data?.map(m => m.StUserId);
      return Promise.all(
        ids.map(m =>
          sdk.users.show(
            {
              id: m,
              include: ['profileImage'],
              'fields.image': [
                'variants.default',
                'variants.square-small',
                'variants.square-small2x',
              ],
            },
            { expand: true }
          )
        )
      );
    })
    .then(res => {
      const result = res.map(m => {
        dispatch(fetchCurrentWorkerUserExtraDetails(m?.data?.data?.id?.uuid)).then(res => {
          Object.assign(m?.data?.data?.attributes?.profile?.publicData, res);
        });
        dispatch(addMarketplaceEntities(m));
        return m.data;
      });
      const data = result.map(m => m.data);
      return data;
    })
    .then(res => {
      const userdata = {
        data: { data: res, meta: paginationDetails },
      };
      dispatch(fetchAllBusinessSuccess(userdata));
    })
    .catch(err => {
      dispatch(fetchAllBusinessError(err));
    });
};
export const loadData = (params, search) => (dispatch, getState, sdk) => {
  const queryParams = parse(search);
  const queryPage = queryParams.page || 1;

  const slug = params.slug;

  const { page = 1 } = parse(search);
  if (queryParams.search) {
    return dispatch(filterSearch(queryParams));
  }
  dispatch(fetchAllBusinessRequest());

  return dispatch(fetchAllBusiness({ page }));
};
